import _ from 'lodash'

function escapeField (field, obj) {
	var escaped = _.cloneDeep(obj)
	escaped[field] = _.escape(obj[field])
	return escaped
}

function map (field) {
	return escapeField.bind(null, field)
}

export default map

map.__filename__ = 'components/map-escape-field.js'
